import { requestBuilder } from '../../../http/RequestBuilder';
import type { PaycheckRoutingConfig } from '../../types/PaycheckRouting';

const useUpdatePaycheckConfig = requestBuilder.mutation<
    PaycheckRoutingConfig,
    Partial<PaycheckRoutingConfig>,
    { configId: string }
>({
    endpoint: ({ configId }) => `/api/paycheck-routing/${configId}`,
    method: 'PATCH',
});

export default useUpdatePaycheckConfig;
